import { render, staticRenderFns } from "./PlatformLabel.vue?vue&type=template&id=b413e372&lang=pug&"
import script from "./PlatformLabel.vue?vue&type=script&lang=js&"
export * from "./PlatformLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports